import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-media-pause",
  "use": "icon-media-pause-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-media-pause\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 11.1729L5.5 2.15038C5.2 1.94987 4.8 1.94987 4.5 2.15038C4.2 2.25063 4 2.55138 4 2.95238V20.9975C4 21.3985 4.2 21.6992 4.5 21.8997C4.7 22 4.8 22 5 22C5.2 22 5.4 21.8997 5.5 21.7995L19.5 12.7769C19.8 12.5764 20 12.2757 20 11.9749C20 11.6742 19.8 11.2732 19.5 11.1729Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol